import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '../shared/shared.module';
import { MenuComponent } from './menu.component';



@NgModule({
  declarations: [MenuComponent],
  imports: [
    SharedModule,
    BsDropdownModule.forRoot()
  ],
  exports:[
    MenuComponent
  ] 
})
export class MenuModule { } 
 